/* loaded by smart-asset */
export default require("./refresh~OoiDvBUe.png")